<template>
    <Menu as="div" class="relative inline-block text-left">
        <div>
            <MenuButton
                class="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500"
            >
                {{ selectedOption.name }}
                <ChevronDownIcon
                    class="-mr-1 ml-2 h-5 w-5"
                    aria-hidden="true"
                />
            </MenuButton>
        </div>

        <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
        >
            <MenuItems
                class="origin-top-left min-h-56 absolute left-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none z-50"
            >
                <div class="py-1">
                    <MenuItem
                        v-for="filter in filters"
                        :key="filter.id"
                        v-slot="{ active }"
                    >
                        <a
                            @click.prevent="handleSelect(filter)"
                            href="#"
                            :class="[
                                active
                                    ? 'bg-gray-100 text-gray-900'
                                    : 'text-gray-700',
                                'block px-4 py-2 text-sm',
                            ]"
                        >{{ filter.name }}</a
                        >
                    </MenuItem>
                </div>
            </MenuItems>
        </transition>
    </Menu>
</template>

<script setup>
import {Menu, MenuButton, MenuItem, MenuItems} from "@headlessui/vue";
import {ChevronDownIcon} from "@heroicons/vue/solid";
import {computed, onMounted, ref} from "vue";
import {v4 as uuidv4} from "uuid";

const props = defineProps(["selected", "section"]);
const emit = defineEmits(["selection"]);
const selectedOption = computed(() => props.selected);
const filters = ref([]);

const handleSelect = (selection) => {
    emit("selection", selection);
    selectedOption.value = selection;
};

onMounted(async () => {
    const {data} = await axios.get("/reports/filters");
    if(props.section === 'weekly'){
        filters.value = data.filter(filter => filter.field === 'status' || filter.field === 'submitted_at');
    } else {
        filters.value = data;
    }

});
</script>
